// A control whose feature is not built yet: the kit's own disabled control (the real disabled
// attribute) with the kit tooltip giving the label and what it will do. Never a button that looks
// live and does nothing. Every id is listed in placeholders.ts.
import type { ReactNode } from 'react';
import { placeholderTip, type PlaceholderId } from './placeholders';
import { Tip } from './Tip';

type Props = {
  id: PlaceholderId;
  /** The kit class of the control it stands in for: btn, chip, mi, bb. */
  className: string;
  children: ReactNode;
  /** Fill the row (and its height), as a menu item or a choice card does. */
  block?: boolean;
};

export function PlaceholderButton({ id, className, children, block = false }: Props) {
  return (
    // The tooltip sits on the wrapper: a disabled button gets no hover or focus of its own, so the
    // wrapper takes keyboard focus and reads the tooltip text.
    <Tip
      text={placeholderTip(id)}
      focusable
      style={block ? { display: 'flex', width: '100%', alignItems: 'stretch' } : undefined}
    >
      <button type="button" className={className} disabled data-placeholder={id}>
        {children}
      </button>
    </Tip>
  );
}
